import { inject, InjectionToken } from '@angular/core';
import { DescService } from '@bufbuild/protobuf';
import { createObservableClient, ObservableClient } from './observable-client';
import { TRANSPORT } from './transport.token';

export function createClientToken<T extends DescService>(
  service: T
): InjectionToken<ObservableClient<T>> {
  return new InjectionToken(`client for ${service.typeName}`, {
    factory() {
      return createObservableClient(service, inject(TRANSPORT));
    },
  });
}
